@if (pageReady) {
  <div class="ssm-info-container">
    <mat-card class="ssm-card" appearance="outlined">
      <mat-card-header class="ssm-card-header">
        <h2 class="ssm-card-title">{{ pageLabels.header }}</h2>
      </mat-card-header>
      <mat-card-content class="ssm-card-content">
        @if (showStopAddress()) {
          <div class="ssm-service-address ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.stopServiceAddressLabel }}</p>
            <p class="ssm-card-section-value" [innerHTML]="getStopAddress()"></p>
          </div>
        }
        @if (showStopDAte()) {
          <div class="ssm-service-address ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.stopServiceDateLabel }}</p>
            <p class="ssm-card-section-value" [innerHTML]="getStopDate()"></p>
          </div>
        }
        @if (showAddressSection()) {
          <div class="ssm-service-address ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.serviceAddressLabel }}</p>
            <p class="ssm-card-section-value" [innerHTML]="formatAddress(true)"></p>
          </div>
          <div class="ssm-mailing-address ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.mailingAddressLabel }}</p>
            <p
              class="ssm-card-section-value"
              [innerHTML]="mailingAddressSame ? formatAddress(true) : formatAddress(false)"
            ></p>
          </div>
        }
        @if (showServiceType()) {
          <div class="ssm-service-service ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.serviceTypeLabel }}</p>
            <p class="ssm-card-section-value">{{ serviceTypeText() }}</p>
          </div>
        }
        @if (showEstimatedDateText()) {
          <div class="ssm-service-service ssm-card-section">
            <p class="ssm-card-section-label">
              {{ pageLabels.estimatedDateText
              }}<i
                #tooltip="matTooltip"
                matTooltip="{{ pageLabels.estimatedDateTooltip }}"
                matTooltipPosition="below"
                matTooltipClass="gs-tooltip"
                (click)="$event.preventDefault(); $event.stopImmediatePropagation(); tooltip.toggle()"
                (keydown.enter)="tooltip.toggle()"
                tabindex="0"
                [attr.aria-label]="pageLabels.estimatedDateTooltip"
                role="tooltip"
                class="gs-tooltip-icon fa-solid fa-circle-question"
              ></i>
            </p>
            <p class="ssm-card-section-value">{{ getEstimatedSwitchStartDateText() }}</p>
          </div>
        }
        @if (showDateSection()) {
          <div class="ssm-service-date ssm-card-section">
            <p class="ssm-card-section-label">
              {{ getDateLabel() }}
              @if (panelData.StartRequest?.StartServiceType !== "MKSW" && !panelData.FirstAvailable) {
                <i
                  #tooltip2="matTooltip"
                  matTooltip="{{ pageLabels.selectedDateToolTip }}"
                  matTooltipPosition="below"
                  matTooltipClass="gs-tooltip"
                  (click)="$event.preventDefault(); $event.stopImmediatePropagation(); tooltip2.toggle()"
                  (keydown.enter)="tooltip2.toggle()"
                  tabindex="0"
                  [attr.aria-label]="pageLabels.selectedDateToolTip"
                  role="tooltip"
                  class="gs-tooltip-icon fa-solid fa-circle-question"
                ></i>
              }
            </p>
            <p class="ssm-card-section-value" [innerHTML]="getDateText()"></p>
          </div>
        }
        @if (showRateSection()) {
          <div class="ssm-service-date ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.newPlanText }}</p>
            <p class="ssm-card-section-value" [innerHTML]="getRateDetailsText()"></p>
          </div>
        }
        @if (showCustomerServiceFee()) {
          <div class="ssm-service-date ssm-card-section">
            <p class="ssm-card-section-label">{{ pageLabels.serviceFeeLabel }}</p>
            <p class="ssm-card-section-value">{{ panelData.CustomerServiceFee | currency }}</p>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
